import React, { useMemo, useState } from 'react';
import styled from 'styled-components';
import { format } from 'date-fns';
import { Text } from '../../../../../common/text/Text';
import { ButtonCustom } from '../../../../../common/button/button';
import { Loader } from '../../../../../common/loader/loader';
import { Lozenge } from '../../../../../common/lozenge/Lozenge';
import { debounce } from '../../../../../searchcontext/adapters/primary/debounce';
import { isClaimSaisineReady } from '../../../../domain/saisine';

const AddClaimSearch = ({
  saisine, eligibleClaims, loading, search, add,
}) => {
  const [text, setText] = useState('');

  const debouncedSearch = useMemo(
    () => debounce((value) => search(saisine._id, value), 300),
    [search, saisine._id],
  );

  const onChange = (event) => {
    setText(event.target.value);
    debouncedSearch(event.target.value);
  };

  const onAdd = (claimId) => {
    add(saisine._id, claimId);
    setText('');
  };

  return (
    <PanelContainer>
      <Text color="secondary" variant="body2">
        {`Ajouter un dossier — seuls les dossiers ${saisine.airline_name} de la juridiction ${saisine.jurisdiction}, avec un vol dans la fenêtre de 30 jours de la room, et qui rentrent dans les ${saisine.remaining().toLocaleString('fr-FR')} € restants sont proposés.`}
      </Text>
      <SearchInput
        type="text"
        placeholder="Rechercher par identifiant AH ou référence de réservation"
        value={text}
        onChange={onChange}
        onFocus={() => debouncedSearch(text)}
      />
      {loading && <Loader size={24} />}
      {!loading && eligibleClaims.map((claim) => (
        <ResultRow key={claim._id}>
          <div>
            <strong>{claim.from_id}</strong>
            {` — ${claim.fullNameMainPassenger()} · `}
            {claim.flight_date ? format(new Date(claim.flight_date), 'dd/MM/yyyy') : '—'}
            {` · ${claim.airport_departure} → ${claim.airport_arrival} · ${claim.passengers.length} pax · ${(claim.compensation_total || 0).toLocaleString('fr-FR')} € `}
            {!isClaimSaisineReady(claim) && <Lozenge text="pax incomplets" red />}
          </div>
          <ButtonCustom text="Ajouter" onClick={() => onAdd(claim._id)} />
        </ResultRow>
      ))}
      {!loading && !eligibleClaims.length
        && <Text color="secondary" variant="body2">Aucun dossier compatible disponible.</Text>}
    </PanelContainer>
  );
};

const PanelContainer = styled.div`
  border: 1px solid #dfe1e6;
  border-radius: 4px;
  padding: 15px;
  margin: 20px 0;
`;

const SearchInput = styled.input`
  width: 100%;
  box-sizing: border-box;
  margin: 10px 0;
  padding: 8px 10px;
  border: 1px solid #dfe1e6;
  border-radius: 4px;
  font-size: 14px;
`;

const ResultRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 10px;
  border-bottom: 1px solid #f4f5f7;
  font-size: 13px;
`;

export {
  AddClaimSearch,
};
